<template>
  <IconLucideCalendar />
</template>
